import React from 'react'
import './footer.css'
import {ImLinkedin} from 'react-icons/im'
import {ImGithub} from 'react-icons/im'
import CV from '../../assets/Syed Mohammad Gouse.pdf'


export default function Footer() {
  return (
    <footer id="nav-menu">
      <a href="/#" className='footer__logo'>SYED</a>
      <ul className='permalinks' width='150%'>
        <li><a href="/#" className="nav-link home" >Home</a></li>
        <li><a href="#about" className="nav-link about">About</a></li>
        <li><a href="#skills" className="nav-link skills" >Skills</a></li>
        <li><a href="#projects" className="nav-link projects">Projects</a></li>
        <li><a href="#contact" className="nav-link contact">Contact</a></li>        
      </ul>
      {/* <div className='footer__socials'>  */}
      {/* https://drive.google.com/file/d/1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z/view */}
      {/* <a href="https://drive.google.com/uc?export=download&id=1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z" download="Syed-Mohammad-Gouse-Resume" style={{width:"80px",alignItems:"center",background:"black",color:"white",height:"33px",padding: "0.2rem 0.8rem",marginTop:"unset",marginRight:"15px"}}
       className='btn nav-link resume' id="resume-button-1" >Resume</a> */}
       <a   href="https://drive.google.com/uc?export=download&id=1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z" onClick={handleDownload} rel="noreferrer" download={'Syed-Mohammad-Gouse-Resume'} style={{width:"80px",alignItems:"center",background:"black",color:"white",height:"33px",padding: "0.2rem 0.8rem",marginTop:"unset",marginRight:"15px"}} id="resume-button-1" className="contact-button nav-link resume resume-button second-btn btn nav-link resume">Resume</a>
      {/* </div> */}
      <div className='footer__socials'>      
      <a href="https://www.linkedin.com/in/mohammad-gouse-syed-9751a5160/" target="blank" rel="noreferrer"><ImLinkedin/></a>
      <a href="https://github.com/syed2605" target="_blank" rel="noreferrer"><ImGithub/></a>
      </div>
      
    </footer>
  )
  function handleDownload () {
    window.open('https://drive.google.com/file/d/1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z/view', '_blank');
  };
}
